export default __webpack_public_path__ + "media/a706df633a2b90c841d9958115b4bbf5d50954db9720f51e4be184c0378328bf.svg";